import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupsCacheKeys: AllRouteEndpoints[] = [];

export const getAppGroupsCacheKey = "/apps/app_groups";
